import React from 'react';
import { Button, Col, Popconfirm, Row, Tooltip, Typography } from 'antd';
import { Field } from 'redux-form';
import get from 'lodash/get';
import { NumberField, SelectField } from 'redux-form-antd';
import FormValueSelector from '../../../containers/FormValueSelector';
import Card from '../Card';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const formItemLayoutInline = {
  colon: false,
  labelCol: {
    xs: { span: 12 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 10 },
  },
};

const pacingTypes = [{ label: 'Daily', value: 'daily' }, { label: 'Total', value: 'total' }];
const ruleOptions = [
  { label: 'Default', value: '3' },
  { label: 'Only Once', value: '1' },
  { label: 'Paced', value: '5' },
];

const CreativeSingle = ({ showCreativeModal, creative_id, creative, removeCreative }) => (
  <Card creative_id={creative_id} key={creative_id}>
    <Row justify="space-between" type="flex">
      <Col style={{ flexGrow: 1 }}>
        <Typography.Title level={4}>{creative.name || `ID: ${creative_id}`}</Typography.Title>
        <Field
          {...formItemLayoutInline}
          label="Rule"
          name={`creative[${creative_id}][type]`}
          parse={a => a && !isNaN(Number(a)) && Number(a)}
          format={a => a && `${a}`}
          options={ruleOptions}
          component={SelectField}
        />

        <FormValueSelector fieldName={`creative[${creative_id}][type]`}>
          {rule =>
            parseInt(rule, 10) === 5 && (
              <Row>
                <Col span={9}>
                  <Field
                    {...formItemLayoutInline}
                    labelCol={{
                      ...formItemLayoutInline.labelCol,
                      sm: { span: 10 },
                    }}
                    label="Impressions"
                    type="text"
                    parse={a => a && !isNaN(Number(a)) && Number(a)}
                    name={`creative[${creative_id}][budget]`}
                    component={NumberField}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    {...formItemLayout}
                    options={pacingTypes}
                    component={SelectField}
                    name={`creative[${creative_id}][rate_type]`}
                  />
                </Col>
              </Row>
            )
          }
        </FormValueSelector>
        <div style={{ marginTop: 10 }}>
          <Tooltip
            title={
              !get(creative, 'creative_service_id') && 'Disabled due to missing creative_service_id'
            }
          >
            <Button
              onClick={() => showCreativeModal(creative)}
              disabled={!get(creative, 'creative_service_id')}
              type="link"
            >
              View Creative
            </Button>
          </Tooltip>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to remove this creative?"
            onConfirm={removeCreative}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link">Remove</Button>
          </Popconfirm>
        </div>
      </Col>
    </Row>
  </Card>
);

export default CreativeSingle;
